export const LocationManager = {
    map: {
        options: {
            maxZoom: 18,
            minZoom: 6,
            scrollwheel: true,
            streetViewControl: false,
            strokeColor: '#40ddbe',
            strokeOpacity: 1,
            strokeWeight: 2,
            styles: [
                {
                    featureType: 'landscape.man_made',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#f7f1df',
                        },
                    ],
                },
                {
                    featureType: 'landscape.natural',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#d0e3b4',
                        },
                    ],
                },
                {
                    featureType: 'landscape.natural.terrain',
                    elementType: 'geometry',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'poi',
                    elementType: 'labels',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'poi.business',
                    elementType: 'all',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'poi.medical',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#fbd3da',
                        },
                    ],
                },
                {
                    featureType: 'poi.park',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#bde6ab',
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'road',
                    elementType: 'labels',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffe15f',
                        },
                    ],
                },
                {
                    featureType: 'road.highway',
                    elementType: 'geometry.stroke',
                    stylers: [
                        {
                            color: '#efd151',
                        },
                    ],
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#ffffff',
                        },
                    ],
                },
                {
                    featureType: 'road.local',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: 'black',
                        },
                    ],
                },
                {
                    featureType: 'transit.station.airport',
                    elementType: 'geometry.fill',
                    stylers: [
                        {
                            color: '#cfb2db',
                        },
                    ],
                },
                {
                    featureType: 'water',
                    elementType: 'geometry',
                    stylers: [
                        {
                            color: '#a2daf2',
                        },
                    ],
                },
            ],
            usePanning: true,
            zoom: 14,
        },
    },
    types: [
        {
            label: 'Land',
            value: 'country',
        },
        {
            label: 'Län',
            value: 'county',
        },
        {
            label: 'Kommun',
            value: 'municipality',
        },
        {
            label: 'Ort',
            value: 'city',
        },
        {
            label: 'Stadsdel',
            value: 'district',
        },
        {
            label: 'Område',
            value: 'area',
        },
        {
            label: 'Plats',
            value: 'place',
        },
    ],
};
